import loadingStatusMixin from './loadingStatus.js';
import { EventBus } from 'relapp-event';

export default {
    mixins: [loadingStatusMixin],
    /**
     * Show the loading progress bar when the component is created and listen to the events triggered by
     * loadingStatusMixin.
     */
    created() {
        this.$on('loading-start', this.listenStartProgress);
        this.$on('loading-stop', this.listenStopProgress);
        this.startLoading();
    },
    /**
     * Removes events we listened to.
     */
    destroyed() {
        this.$off('loading-start', this.listenStartProgress);
        this.$off('loading-stop', this.listenStopProgress);
    },
    methods: {
        /**
         * Show the loading progress bar. This is triggered if loading starts.
         */
        listenStartProgress() {
            EventBus.$emit('loading-start');
        },
        /**
         * Finish the progress loading bar. This is triggered if loading ends.
         */
        listenStopProgress() {
            EventBus.$emit('loading-stop');
        }
    }
};
